import { render, staticRenderFns } from "./CdbCustomerBasicEidt.vue?vue&type=template&id=7971eb43&scoped=true&"
import script from "./CdbCustomerBasicEidt.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerBasicEidt.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerBasicEidt.vue?vue&type=style&index=0&id=7971eb43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971eb43",
  null
  
)

export default component.exports